import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
    to: string;
    label: React.ReactNode;
    icon: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

const MenuLink: React.FC<LinkProps> = ({ to, label, icon, disabled, className }) => {
    return (
        <li className={`${disabled ? 'pointer-events-none opacity-25' : ''}`}>
            <RouterLink to={to} className={`flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] focus:bg-transparent focus:text-white transition-all outline-none hover:bg-[#2020324D] group ${className}`}>
                {icon &&
                    <div className='flex justify-center items-center w-[1.675rem]'>
                        {icon}
                    </div>
                }
                <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">{label}</span>
            </RouterLink>
        </li>
    );
};

export default MenuLink;